<template>
  <div>
    <div class="pg-cab">
      <div class="col">
        <span class="tag">Processo</span>
        <h1>Como funciona</h1>
        <p class="sub">
          Do pedido à entrega, sem etapa escondida. Valor e janela de coleta são
          confirmados antes de qualquer deslocamento.
        </p>
      </div>
    </div>

    <ProcessoSecao />

    <section class="sec">
      <div class="col">
        <div class="sec-cab">
          <h2 class="sec-h2">Perguntas frequentes</h2>
          <span class="sec-p obs-linha">{{ FAQ.length }} respostas</span>
        </div>

        <div class="faq">
          <details v-for="(f, i) in FAQ" :key="i" class="q">
            <summary>
              <span class="n">{{ String(i + 1).padStart(2, '0') }}</span>
              <span class="p">{{ f.p }}</span>
              <span class="sinal" aria-hidden="true"></span>
            </summary>
            <div class="r">{{ f.r }}</div>
          </details>
        </div>
      </div>
    </section>

    <CtaSection />
  </div>
</template>

<script setup>
import ProcessoSecao from '@/components/ProcessoSecao.vue'
import CtaSection from '@/components/CtaSection.vue'
import { OPERACAO, RESTRICOES } from '@/config/operacao'

const FAQ = [
  {
    p: 'Vocês coletam no mesmo dia?',
    r: `Sim, para pedidos confirmados até ${OPERACAO.limitePedido}, dentro da área de cobertura. Depois desse horário, a coleta entra para o próximo dia útil.`,
  },
  {
    p: 'Como o valor do frete é calculado?',
    r: 'Por rota, peso, volume, urgência e — no caso de produto perigoso — pela classe de risco e pelo veículo que ela exige. O valor é fechado antes da coleta e não muda depois, salvo se você alterar o pedido durante a execução.',
  },
  {
    p: 'O que vocês precisam saber para transportar produto perigoso?',
    r: 'A classe de risco, o número ONU e a quantidade, que constam na nota fiscal e na ficha do produto. Com isso confirmamos se a carga é transportável, qual veículo ela exige e qual documentação acompanha o embarque — tudo antes de fechar o pedido.',
  },
  {
    p: 'Que tipo de carga vocês não transportam?',
    r: `${RESTRICOES} Também trabalhamos com carga seca comum, dedicada ou em roteiro programado.`,
  },
  {
    p: 'Como acompanho a minha entrega?',
    r: 'Um código de acompanhamento é emitido no embarque e enviado a você. Com ele dá para consultar a etapa atual na página de rastreio.',
  },
  {
    p: 'Quem transporta a minha carga?',
    r: 'Motoristas parceiros e veículos agregados selecionados e coordenados diretamente pela Flor de Goiás. Para produto perigoso, o motorista precisa ser habilitado para o transporte desse tipo de carga. A responsabilidade sobre a mercadoria é nossa, do embarque até a confirmação de entrega.',
  },
  {
    p: 'Atendem fora da lista de municípios?',
    r: 'Sob consulta, desde que a rota seja operacionalmente viável a partir da nossa base. Confirme antes de fechar o pedido.',
  },
  {
    p: 'Dá para combinar coleta recorrente?',
    r: 'Sim. Para quem despacha com frequência, montamos roteiro em dias e horários fixos, com condição comercial acordada.',
  },
]
</script>

<style scoped>
.cabeca { border-bottom: 1px solid var(--fio); padding: 128px 0 40px; background: var(--nevoa); }
.cabeca h1 {
  font-family: 'Archivo', sans-serif;
  font-weight: 900;
  font-size: clamp(32px, 4vw, 54px);
  letter-spacing: -.045em;
  line-height: 1;
  margin-top: 12px;
}
.sub { margin-top: 16px; font-size: 16px; line-height: 1.6; color: var(--grafite); max-width: 540px; }

.faq { border-top: 1px solid var(--fio-forte); }
.q { border-bottom: 1px solid var(--fio); }
summary {
  display: grid;
  grid-template-columns: 52px 1fr 24px;
  align-items: center;
  gap: 12px;
  padding: 19px 0;
  cursor: pointer;
  list-style: none;
}
summary::-webkit-details-marker { display: none; }
.n {  font-size: 11px; color: var(--azul-esc); letter-spacing: .08em; }
.p { font-family: 'Archivo', sans-serif; font-weight: 700; font-size: 16.5px; letter-spacing: -.02em; }
.q:hover .p { color: var(--azul-esc); }

/* sinal +/− desenhado com fio, sem ícone */
.sinal { position: relative; width: 13px; height: 13px; justify-self: end; }
.sinal::before, .sinal::after { content: ''; position: absolute; background: var(--tinta); transition: transform .2s ease; }
.sinal::before { top: 6px; left: 0; width: 13px; height: 1.5px; }
.sinal::after { left: 6px; top: 0; width: 1.5px; height: 13px; }
.q[open] .sinal::after { transform: scaleY(0); }

.r { padding: 0 0 22px 64px; font-size: 14.5px; line-height: 1.68; color: var(--grafite); max-width: 720px; }

@media (max-width: 700px) {
  summary { grid-template-columns: 34px 1fr 20px; gap: 9px; }
  .p { font-size: 15px; }
  .r { padding-left: 43px; }
}
</style>
